import { nodeAdapter } from "./runtime";
import { runPreview } from "./preview.impl";

await runPreview(nodeAdapter);
